<template>
  <h1>{{ pageHeading }}</h1>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NonPersonalisedPageHeading',
  computed: {
    ...mapGetters(['pageHeading'])
  }
}
</script>
